export const styles = {
  productWraper: {
    display: 'flex',
    flexWrap: 'wrap'
  }
}



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/HeroLocations/styles.js